module.exports = __webpack_public_path__ + "img/stock5.30106768.png";